/* eslint-disable react/no-multi-comp */
import React from 'react';
import { palette } from '../../styles/theme';

export function MailSVG ({ className = '' }) {
    return (
        <span className={className}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path d="M3 9.557V17C3 17.7956 3.31607 18.5587 3.87868 19.1213C4.44129 19.6839 5.20435 20 6 20H18C18.7956 20 19.5587 19.6839 20.1213 19.1213C20.6839 18.5587 21 17.7956 21 17V8C21 7.20435 20.6839 6.44129 20.1213 5.87868C19.5587 5.31607 18.7956 5 18 5H6C5.20435 5 4.44129 5.31607 3.87868 5.87868C3.31607 6.44129 3 7.20435 3 8V9.557ZM6 6.5H18C18.3978 6.5 18.7794 6.65804 19.0607 6.93934C19.342 7.22064 19.5 7.60218 19.5 8V9.11L12 13.148L4.5 9.11V8C4.5 7.60218 4.65804 7.22064 4.93934 6.93934C5.22064 6.65804 5.60218 6.5 6 6.5ZM4.5 10.814L11.6445 14.66C11.7538 14.7188 11.8759 14.7496 12 14.7496C12.1241 14.7496 12.2462 14.7188 12.3555 14.66L19.5 10.814V17C19.5 17.3978 19.342 17.7794 19.0607 18.0607C18.7794 18.342 18.3978 18.5 18 18.5H6C5.60218 18.5 5.22064 18.342 4.93934 18.0607C4.65804 17.7794 4.5 17.3978 4.5 17V10.814Z" fill="#F4AB34" />
            </svg>
        </span>
    );
}

export function MailIconSVG ({ customStroke = palette.secondary[600], className = '' }) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <g clipPath="url(#clip0_6755_12749)">
                <path d="M4 9.33366C4 8.62641 4.28095 7.94814 4.78105 7.44804C5.28115 6.94794 5.95942 6.66699 6.66667 6.66699H25.3333C26.0406 6.66699 26.7189 6.94794 27.219 7.44804C27.719 7.94814 28 8.62641 28 9.33366V22.667C28 23.3742 27.719 24.0525 27.219 24.5526C26.7189 25.0527 26.0406 25.3337 25.3333 25.3337H6.66667C5.95942 25.3337 5.28115 25.0527 4.78105 24.5526C4.28095 24.0525 4 23.3742 4 22.667V9.33366Z" stroke={customStroke} strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M4 9.33301L16 17.333L28 9.33301" stroke={customStroke} strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_6755_12749">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
